import { SpecialOfferState, RootState } from '@/types/store'
import { Module } from 'vuex'

import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'

export const initSpecialOffer = {
  id: '',
  createdAt: '',
  updatedAt: '',
  deletedAt: null,
  productName: '',
  productNameSecond: '',
  title: '',
  offerInformation: '',
  aboutProduct: '',
  productSiteUrl: null,
  companyName: '',
  targetAgeText: null,
  targetPurchasePeriodText: '',
  displayEndAt: '',
  displayStartAt: '',
  status: 'active' as const,
  nameAdmin: '',
  chainStoreNames: [],
  pobCategoryIds: [],
  itemNames: [],
  itemNameSeconds: [],
  canFreeItemName: false,
  canFreeItemNameSecond: false,
  canFreeChainStoreName: false,
  needsLeaderCheck: false,
  receipts: [],
  total: 0,
  unchecked: 0,
  uncheckedNg: 0,
  uncheckedOk: 0,
  leaderChecked: 0,
  leaderNg: 0,
  checkpoints: '', // v2では未実装
  targetProductAdmin: '', // v2では未実装
}

const state: SpecialOfferState = {
  isSpecialOfferLoading: false,
  specialOffer: initSpecialOffer,
  specialOffers: [],
}

export const specialOffer: Module<SpecialOfferState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
